
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class TimeSinceFormatter extends Component {

    render() {
        const { sinceDate } = this.props;
        if (!sinceDate) {
            return null;
        }
        return (
                <span id='duration'>{this.getTimeSince(sinceDate)}</span>
            );
    } 
    getTimeSince(sinceDate) {
        var displayingSomething = false;
        var now = new Date().getTime();
        var t = new Date(sinceDate).getTime();
        var seconds = Math.floor((now - t) / 1000);
        var minutes = seconds / 60;
        var hours = minutes / 60;
        var days = hours / 24;
        days = Math.floor(days);
        hours -= 24 * days;
        minutes -= 24 * 60 * days;
        hours = Math.floor(hours);
        minutes -= 60 * hours;
        minutes = Math.floor(minutes);
        var out = "";
        if (days) {
            displayingSomething = true;
            out += days;
            out += " day";
            out += days !== 1 ? "s " : " ";
        }
        if (hours) {
            displayingSomething = true;
            out += hours;
            out += " hour";
            out += hours !== 1 ? "s " : " ";
        }
        if (minutes || !displayingSomething) {
            out += minutes;
            out += " minute";
            out += minutes !== 1 ? "s " : " ";
        }
        return out;
    }
}

TimeSinceFormatter.propTypes = {
    sinceDate: PropTypes.string
};

export default TimeSinceFormatter;










